import { z } from 'zod';

export const OnboardingPathValues = [
  'gb_sdd',
  'gb_regular',
  'gb_full',
  'eu_low',
  'eu_medium',
  'eu_high',
  'fr_business_low',
  'fr_business_medium',
  'fr_business_high',
  'eu_wm',
  'eu_wm_business',
] as const;
export const ZodOnboardingPath = z.enum(OnboardingPathValues);
export type OnboardingPath = z.TypeOf<typeof ZodOnboardingPath>;

export type DBProofOfAddressState = 'uploaded' | 'not_uploaded' | 'retry_upload';
